import PropTypes from "prop-types";

export default {
  // Popupを表示させるためのイベント
  onClickPopupLink: PropTypes.func.isRequired,
  // Popupクローズ時に選択した要素の名前一覧を受け取るためのイベント
  onChangeInputValue: PropTypes.func.isRequired,
  // 選択された名前一覧
  inputValue: PropTypes.string.isRequired
};
